import { faSort, faSortAlphaDown, faSortAlphaDownAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatMessage } from 'i18n/CurrentLocale';
import { ModalEnum } from 'myParkdUtils/enums';
import { Fragment } from 'react';
import { RowInfo } from 'react-table';
import DriverRenderer from './DriverRenderer';
import ClickableInfoIcon from '../ClickableInfoIcon';
import ParkingModeDropdown from './ParkingModeDropdown';
import LicensePlateRenderer from './LicensePlateRenderer';
import ConnectionRenderer from './ConnectionRenderer';
import PermissionRenderer from './PermissionRenderer';
import EditWorkingHoursButton from 'components/workinghours/EditWorkingHoursButton';
import EditableTableField from 'components/EditableTableField';
import { ColumnVisibility, OptionalColumn } from 'screens/modals/ManageTableColumnsModal';
import { VehicleAndDriver } from 'types';


export const OPTIONAL_VEHICLES_TABLE_COLUMNS: OptionalColumn[] = [
    { accessorKey: 'vehicle.costCenter', displayNameId: 'COST_CENTER' },
    { accessorKey: 'vehicle.connection', displayNameId: 'CONNECTION' },
    { accessorKey: 'vehicle.workingHours', displayNameId: 'WORKING_HOURS_LP_COLUMN_TITLE' },
]


export const getCompanyVehicleColumns = (vehiclesTableColumnSettings: ColumnVisibility, licensePlateFilter: string, onLicensePlateFilterChange: Function) => [
    {
        Header: (
            <>
                <span>{formatMessage({ id: 'VEHICLES_TABLE_COLUMN_STATUS' })}</span>
                <ClickableInfoIcon
                    modal={ModalEnum.INFO_MODAL}
                    modalTitleFormattedMessageId='INFO_MODAL_LICENSE_PLATE_STATUS_TITLE'
                    modalTextFormattedMessageId='INFO_MODAL_LICENSE_PLATE_STATUS_TEXT'
                />
            </>
        ),
        accessor: 'vehicle.rights',
        id: 'rights',
        filterable: false,
        sortable: false,
        Cell: (row: RowInfo) => (
            <PermissionRenderer vehicle={row.original.vehicle} />
        ),
        maxWidth: 190
    },
    {
        Header: (
            <Fragment>
                <span>{formatMessage({ id: 'LICENSE_PLATE' })}</span>
                <FontAwesomeIcon icon={faSort} className="header-icon-sorting" />
                <FontAwesomeIcon icon={faSortAlphaDown} className="header-icon-asc" />
                <FontAwesomeIcon icon={faSortAlphaDownAlt} className="header-icon-desc" />
            </Fragment>
        ),
        accessor: 'vehicle.localizedLicensePlate.licensePlate',
        id: 'licensePlate',
        filterable: true,
        Filter: (
            <input
                className="custom-filter-input"
                data-testid="licenseplate-filter-input"
                placeholder={formatMessage({ id: 'PLACEHOLDER_SEARCH' })}
                value={licensePlateFilter}
                onChange={(e) => onLicensePlateFilterChange(e.target.value)}
            />
        ),
        Cell: (row: RowInfo) => <LicensePlateRenderer vehicleAndDriver={row.original} />,
        className: 'cell-bold cell-licenseplate',
        //minWidth: 100,
        //maxWidth: 350,
    },
    {
        Header: (
            <Fragment>
                <span>{formatMessage({ id: 'DRIVER' })}</span>
                <FontAwesomeIcon icon={faSort} className="header-icon-sorting" />
                <FontAwesomeIcon icon={faSortAlphaDown} className="header-icon-asc" />
                <FontAwesomeIcon icon={faSortAlphaDownAlt} className="header-icon-desc" />
            </Fragment>
        ),
        accessor: 'user.fullName',
        id: 'ec.user.familyName',
        filterable: false,
        Cell: (row: RowInfo) => (
            <DriverRenderer vehicleAndDriver={row.original} />
        ),
        className: 'cell-driver',
        //minWidth: 150,
        //maxWidth: 400,
    },
    {
        Header: (
            <Fragment>
                <span>{formatMessage({ id: 'PARKING_MODE' })}</span>
                <ClickableInfoIcon modal={ModalEnum.INFO_MODAL_PARKING_MODE} />
            </Fragment>
        ),
        accessor: 'vehicle.mode',
        id: 'mode',
        sortable: false,
        Cell: (row: RowInfo) => (
            <ParkingModeDropdown vehicle={row.original.vehicle} />
        ),
        className: 'cell-devicemode',
        filterable: false,
        //maxWidth: 400,
    },
    {
        Header: formatMessage({ id: 'COST_CENTER' }),
        accessor: 'vehicle.costCenter',
        id: 'vehicle.costCenter',
        show: !!vehiclesTableColumnSettings?.['vehicle.costCenter'],
        Cell: (row: { original: VehicleAndDriver }) => (
            <EditableTableField
                defaultValue={row.original.vehicle?.costCenter!}
                placeholder={formatMessage({ id: 'PLACEHOLDER_ADD_COST_CENTER' })}
                modalName={ModalEnum.EDIT_COST_CENTER}
                rowData={row.original.vehicle}
            />
        ),
        filterable: false,
        sortable: false
    },
    {
        Header: formatMessage({ id: 'CONNECTION' }),
        accessor: 'vehicle.connection',
        id: 'deviceType',
        show: !!vehiclesTableColumnSettings?.['vehicle.connection'],
        sortable: false,
        Cell: ({ value }: any) => (<ConnectionRenderer connection={value} />),
        className: 'cell-connection',
        filterable: false,
    },
    {
        header: () => { },
        Header: (
            <Fragment>
                {formatMessage({ id: 'WORKING_HOURS_LP_COLUMN_TITLE' })}
                <ClickableInfoIcon
                    modal={ModalEnum.INFO_MODAL}
                    modalTitleFormattedMessageId='INFO_MODAL_LP_WORKING_HOURS_TITLE'
                    modalTextFormattedMessageId='INFO_MODAL_LP_WORKING_HOURS_TEXT'
                />
            </Fragment>
        ),
        accessor: 'vehicle.workingHours',
        id: 'workingHours',
        show: !!vehiclesTableColumnSettings?.['vehicle.workingHours'],
        sortable: false,
        filterable: false,
        Cell: (row: RowInfo) => (<EditWorkingHoursButton vehicle={row.original.vehicle} />),
    }
];
